import { createFileRoute } from "@tanstack/react-router";

import { routeHead } from "@/lib/seo-head";
import RenovationInterieureLyon from "@/pages/RenovationInterieureLyon";

export const Route = createFileRoute("/renovation-interieure-lyon")({
  head: () =>
    routeHead({
      path: '/renovation-interieure-lyon',
      title: 'Rénovation intérieure Lyon & Ouest Lyonnais | JIIA Studio',
      description: "Rénovation d'appartement et de maison à Lyon : conception, consultation des artisans et suivi de chantier jusqu'à la réception.",
    }),
  component: RenovationInterieureLyon,
});
